module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-success no-padding"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('chart-line', {
    attrs: {
      "chart-data": _vm.chartData,
      "height": 240
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "pull-left text-center",
    staticStyle: {
      "width": "150px",
      "border-right": "1px solid #eee"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_delivery_system@3x.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorEntered
    })
  }, [_vm._v("\n                    " + _vm._s(_vm.totalGuidesTransit)), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-unit"
  }, [_vm._v("Guías de Remisión")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("en Tránsito")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-center",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_delivery_shipped@3x.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "22"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorDelivered
    })
  }, [_vm._v("\n                    " + _vm._s(_vm.totalGuidesDelivered)), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-unit"
  }, [_vm._v("Guías de Remisión")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Entregadas")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/entregadas.png"
    }
  }), _vm._v(" Transporte")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78231c4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/TransportSummary.vue
// module id = 532
// module chunks = 1